export default [
  {
    name: 'Classic',
    tagline: 'Find great candidates with our basic ad',
  },
  {
    name: 'StandOut',
    tagline: 'Promote your brand to attract the right candidate',
  },
  {
    name: 'Premium',
    tagline: 'Attract more candidates with a featured listing',
  },
];
